import { WidgetControlType } from '@examdojo/core/widget';
import type { ArithmeticSeriesPreset } from './arithmetic-series-preset.model';

export const ARITHMETIC_SERIES_EXPLORATION_PRESET: ArithmeticSeriesPreset = {
  id: 'exploration',
  title: 'Exploration Mode',
  description: 'Interactive exploration of arithmetic series with hover to see partial sums',
  config: {
    id: 'arithmetic-series-exploration',
    type: 'arithmetic-series',
    params: {
      a: 2,
      d: 3,
      numTerms: 7,
    },
    display: {
      grid: false,
      axes: false,
      sumLine: { enabled: true },
      bars: { enabled: true },
      points: { enabled: true },
      termLabels: { enabled: true },
      sumTooltip: true,
    },
    behavior: {
      features: {
        sliders: false,
        interaction: true,
      },
      controls: [
        {
          id: 'slider-a',
          type: WidgetControlType.Slider,
          label: 'First term a',
          param: 'a',
          position: 'canvas-overlay',
          min: -10,
          max: 20,
          step: 1,
          defaultValue: 2,
          editable: true,
          color: 'pink',
          trigger: { action: 'UPDATE_PARAMS', payload: { param: 'a' } },
        },
        {
          id: 'slider-d',
          type: WidgetControlType.Slider,
          label: 'Common difference d',
          param: 'd',
          position: 'canvas-overlay',
          min: -5,
          max: 10,
          step: 0.5,
          defaultValue: 3,
          editable: true,
          color: 'sky',
          trigger: { action: 'UPDATE_PARAMS', payload: { param: 'd' } },
        },
      ],
    },
  },
};
